import React from 'react'
import getConfig from 'next/config'
import { FacebookFilled, GoogleOutlined } from '@ant-design/icons'
import { Row, Col } from 'antd'
import Button from 'components/shared/button'

const { publicRuntimeConfig } = getConfig()

const providersIcon = {
  facebook: { icon: <FacebookFilled />, label: `SignIn with Facebook` },
  google: { icon: <GoogleOutlined />, label: `SignIn with Google` },
}

export default function SocialLink() {
  return (
    <Row className="linksContainer">
      <Col span="24">
        <div className="socialLinkContainer">
          <Button
            type="primary"
            href={`${publicRuntimeConfig.cmsRootUrl}/api/connect/facebook`}
            style={{ width: '100%' }}
            className="facebook"
            source="facebook-login"
          >
            {providersIcon.facebook.icon}
            {providersIcon.facebook.label}
          </Button>
        </div>

        <div className="socialLinkContainer">
          <Button
            href={`${publicRuntimeConfig.cmsRootUrl}/api/connect/google`}
            type="primary"
            style={{ width: '100%' }}
            className="google"
            source="google-login"
          >
            {providersIcon.google.icon}
            {providersIcon.google.label}
          </Button>
        </div>
      </Col>
    </Row>
  )
}
